// @flow
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const LOADING = 'LOADING'
export const IN = 'IN'
export const KK_DATA='KK_DATA'
export const CATEGORY_LIST='CATEGORY_LIST'
export const COMPANY_MEMBER_DETAILS='COMPANY_MEMBER_DETAILS'

